
    import {
      getAllUsers,
      createUser,
      createAllUsers,
      updateUser,
      deleteUser
    } from "@/services/user";

    const state = {
      users: [],
      processed: false
    };

    const getters = {
      getUsers(state) {
        return state.users;
      },
      userProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchUsers({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllUsers(
              params
            )
              .then(response => {
                commit("SET_USERS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createUser({ commit }, user) {
          return new Promise((resolve, reject) => {
            createUser(user)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllUsers({ commit }, users) {
          return new Promise((resolve, reject) => {
            createAllUsers(users)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateUser({ commit }, user) {
          return new Promise((resolve, reject) => {
            updateUser(user)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteUser({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteUser(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_USERS(state, data) {
        state.users = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    